<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1 flex items-center gap-3">
      <mat-card-title class="">{{ viewOnly && !(showEmergencial && isEmergencial) ? 'Visualizar' : 'Editar' }} Item proposta</mat-card-title>
      @if (showEmergencial && isEmergencial) {
        <span class="emergencial-badge">⚡ Emergencial</span>
      }
      @if (item?.temDesconto) {
        <div
          class="flex items-center gap-1 text-green-600"
          matTooltip="Desconto aplicado por {{ item.usuarioDescontoEmail || '-' }} em {{ item.dataDesconto || '-' }}"
        >
          <mat-icon>sell</mat-icon>
          <span class="text-sm font-medium">Desconto aplicado</span>
        </div>
      }
      @if (item?.dataSolicitacaoCompras && item.dataSolicitacaoCompras !== '01/01/0001') {
        <div class="flex items-center gap-1 text-blue-600">
          <mat-icon>shopping_cart</mat-icon>
          <span class="text-sm font-medium">
            Enviado ao Compras em {{ item.dataSolicitacaoCompras }}
            às {{ item.horaSolicitacaoCompras?.slice(0, 5) }}
          </span>
        </div>
      }
      @if (
        item?.dataFinalizacaoCompras &&
        item.dataFinalizacaoCompras !== '01/01/0001' &&
        item.statusId !== ITEM_PROPOSTA_STATUS.AGUARDANDO_COMPRAS
      ) {
        <div class="flex items-center gap-1 text-green-600">
          <mat-icon>assignment_return</mat-icon>
          <span class="text-sm font-medium">
            Devolvido pelo Compras em {{ item.dataFinalizacaoCompras }}
            às {{ item.horaFinalizacaoCompras?.slice(0, 5) }}
          </span>
        </div>
      }
    </div>
    <button mat-flat-button class="btn-tg-white w-1/12" (click)="close()">
      Voltar
    </button>
    @if (!viewOnly || (showEmergencial && isEmergencial)) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="!checkForm() || loading || paradasIncompletas"
        (click)="editItemProposal()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          {{ showEmergencial && isEmergencial ? 'Salvar' : 'Editar' }}
        }
      </button>
    }
  </mat-card-header>
  <div class="my-4"></div>
  @if (!loadingInfo) {
    <mat-spinner class="loading-spinner"></mat-spinner>
  } @else {
    <div>
      <mat-accordion multi>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title> <h4>Item Proposta</h4> </mat-panel-title>
          </mat-expansion-panel-header>
          <div [formGroup]="form" class="mt-4 container mx-auto">
            <div class="mb-3">
              <search-tariff-proposal
                (selectItemEvent)="selectTariff($event)"
                (locationEvent)="locationTariff($event)"
                [tariffSelected]="tariffSelected"
                [idClient]="idClient"
                [paradasFilter]="paradas"
                [edit]="edit"
                [viewOnly]="viewOnly"
                [lockSelection]="descontoAplicado"
                [proposal]="proposal"
              />
            </div>
            <div class="mb-3 mt-3">
              <parada-itinerario-editor
                [paradas]="paradas"
                [readonly]="viewOnly || descontoAplicado"
                [location]="editorLocation"
                [warnIncompleteParada]="true"
                (paradasChange)="onParadasChange($event)"
              />
            </div>
            <div class="flex justify-between items-center mt-8 -mx-2">
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Valor custo</mat-label>
                @if (form.get('cost')!.value != '') {
                  <span matTextPrefix>R$&nbsp;</span>
                }
                <input matInput formControlName="cost" currencyInput (blur)="calculateValues()" />
              </mat-form-field>

              <!--            <mat-form-field-->
              <!--              class="input-tg w-2/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Custo hora extra</mat-label>-->
              <!--              @if (form.get('costOvertime')!.value != '') {-->
              <!--                <span matTextPrefix>R$&nbsp;</span>-->
              <!--              }-->
              <!--              <input matInput formControlName="costOvertime" currencyInput />-->
              <!--            </mat-form-field>-->

              <!--            <mat-form-field-->
              <!--              class="input-tg w-2/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Custo Km extra</mat-label>-->
              <!--              @if (form.get('costKmExtra')!.value != '') {-->
              <!--                <span matTextPrefix>R$&nbsp;</span>-->
              <!--              }-->
              <!--              <input matInput formControlName="costKmExtra" currencyInput />-->
              <!--            </mat-form-field>-->

              <div class="w-6/12 px-2">
                <div class="box-form">
                  <h4 class="bg-gray">Comissão | Divisor | Taxa</h4>
                  <div
                    class="input-box flex justify-between items-center w-full"
                  >
                    <mat-form-field
                      class="input-tg w-3/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Tipo</mat-label>
                      <mat-select
                        formControlName="typeCommission"
                        (selectionChange)="onSelectionChangeType($event)"
                      >
                        @for (type of listCommission; track type) {
                          <mat-option
                            [value]="type.value"
                            [disabled]="type.disabled"
                          >
                            {{ type.description }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field
                      class="input-tg w-3/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Comissão</mat-label>
                      @if (form.get('commission')!.value != '') {
                        <span matTextSuffix>%&nbsp;</span>
                      }
                      <input
                        matInput
                        formControlName="commission"
                        decimalInput
                        (blur)="calculateValues()"
                      />
                    </mat-form-field>
                    <mat-form-field
                      class="input-tg w-3/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Divisor</mat-label>
                      <input
                        matInput
                        formControlName="divider"
                        decimalInput
                        (blur)="calculateValues()"
                      />
                    </mat-form-field>
                    <mat-form-field
                      class="input-tg w-3/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Taxa</mat-label>
                      @if (form.get('tax')!.value != '') {
                        <span matTextSuffix>%&nbsp;</span>
                      }
                      <input
                        matInput
                        formControlName="tax"
                        currencyInput
                        (blur)="calculateValues()"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Quant. veículo</mat-label>
                <input
                  matInput
                  formControlName="numVehicle"
                  integerInput
                  (blur)="calculateValues()"
                />
              </mat-form-field>

              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Quant. pessoas</mat-label>
                <input matInput formControlName="numPeople" integerInput />
              </mat-form-field>
            </div>
            <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
              <div class="w-full px-2">
                <div class="box-form">
                  <h4 class="bg-gray">Venda</h4>
                  <div
                    class="input-box flex justify-between items-center w-full"
                  >
                    <mat-form-field
                      class="input-tg w-2/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Valor unitário</mat-label>
                      @if (form.get('saleUnit')!.value != '') {
                        <span matTextPrefix>R$&nbsp;</span>
                      }
                      <input
                        matInput
                        formControlName="saleUnit"
                        currencyInput
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="input-tg w-2/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Hora extra</mat-label>
                      @if (form.get('saleOvertime')!.value != '') {
                        <span matTextPrefix>R$&nbsp;</span>
                      }
                      <input
                        matInput
                        formControlName="saleOvertime"
                        currencyInput
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="input-tg w-2/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Km extra</mat-label>
                      @if (form.get('saleKmExtra')!.value != '') {
                        <span matTextPrefix>R$&nbsp;</span>
                      }
                      <input
                        matInput
                        formControlName="saleKmExtra"
                        currencyInput
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="input-tg w-2/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Valor sem Taxa</mat-label>
                      @if (form.get('saleTotal')!.value != '') {
                        <span matTextPrefix>R$&nbsp;</span>
                      }
                      <input
                        matInput
                        formControlName="saleTotal"
                        currencyInput
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="input-tg w-2/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Valor taxa</mat-label>
                      @if (form.get('taxValue')!.value != '') {
                        <span matTextPrefix>R$&nbsp;</span>
                      }
                      <input
                        matInput
                        formControlName="taxValue"
                        currencyInput
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="input-tg w-2/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Valor com Taxa</mat-label>
                      @if (form.get('saleTotalTax')!.value != '') {
                        <span matTextPrefix>R$&nbsp;</span>
                      }
                      <input
                        matInput
                        formControlName="saleTotalTax"
                        currencyInput
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
              <div class="w-4/12 px-2">
                <div class="box-form">
                  <h4 class="bg-gray">Inicio</h4>
                  <div
                    class="input-box flex justify-between items-center w-full"
                  >
                    <mat-form-field
                      class="input-tg w-8/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Data</mat-label>
                      <input
                        matInput
                        [matDatepicker]="dateStart"
                        (focus)="openDatepicker('dateStart')"
                        formControlName="dateStart"
                        [max]="this.form.get('dateEnd')!.value"
                        readonly
                      />
                      <mat-datepicker-toggle
                        matIconSuffix
                        [for]="dateStart"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #dateStart></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field
                      class="input-tg w-4/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Hora (24h)</mat-label>
                      <input matInput type="time" formControlName="timeStart" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="w-4/12 px-2">
                <div class="box-form">
                  <h4 class="bg-gray">Fim</h4>
                  <div
                    class="input-box flex justify-between items-center w-full"
                  >
                    <mat-form-field
                      class="input-tg w-8/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Data</mat-label>
                      <input
                        matInput
                        [matDatepicker]="dateEnd"
                        (focus)="openDatepicker('dateEnd')"
                        [min]="this.form.get('dateStart')!.value"
                        formControlName="dateEnd"
                        readonly
                      />
                      <mat-datepicker-toggle
                        matIconSuffix
                        [for]="dateEnd"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #dateEnd></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field
                      class="input-tg w-4/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Hora (24h)</mat-label>
                      <input matInput type="time" formControlName="timeEnd" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <!--            <mat-form-field-->
              <!--              class="input-tg w-2/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Quant. veículo</mat-label>-->
              <!--              <input-->
              <!--                matInput-->
              <!--                formControlName="numVehicle"-->
              <!--                integerInput-->
              <!--                (blur)="calculateValues()"-->
              <!--              />-->
              <!--            </mat-form-field>-->

              <!--            <mat-form-field-->
              <!--              class="input-tg w-2/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Quant. pessoas</mat-label>-->
              <!--              <input matInput formControlName="numPeople" integerInput />-->
              <!--            </mat-form-field>-->
              <mat-checkbox class="input-tg w-1/12" formControlName="isCourtesy"
                ><h3>Cortesia</h3></mat-checkbox
              >
              <mat-checkbox class="input-tg w-1/12" formControlName="isExchange"
                ><h3>Permuta</h3></mat-checkbox
              >
              <mat-checkbox
                class="input-tg w-2/12"
                formControlName="isCommission"
                ><h3>Se comissiona</h3></mat-checkbox
              >
            </div>
            <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
              <mat-form-field
                class="input-tg w-10/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Observação</mat-label>
                <textarea matInput formControlName="observation"></textarea>
              </mat-form-field>
              <mat-slide-toggle
                class="input-tg w-2/12 px-2"
                formControlName="mostrarObsPdf"
              >
                Exibir Obs Para cliente
              </mat-slide-toggle>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  }
</mat-card>
